<template>
  <main>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Lihat Data Keluarga</p>
                <argon-button color="danger" size="sm" class="ms-auto" @click="back()"
                  >Kembali</argon-button
                >
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Wilayah</label
                      >
                      <VueMultiselect
                        v-model="datas.WILAYAH"
                        :options="data_wilayah"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="-"
                        label="wilayah"
                        track-by="wilayah"
                        :disabled="true"
                      />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Sektor</label
                      >
                      <VueMultiselect
                        v-model="datas.SEKTOR"
                        :options="data_sektor"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="-"
                        label="nama"
                        track-by="nama"
                        :disabled="true"
                      />
                    </div>
                    <div class="col-md-12">
                      <label for="example-text-input" class="form-control-label"
                        >Nomor KK</label
                      >
                      <argon-input type="text" v-model:value="datas.ID_KELUARGA" disabled="true" />
                    </div>
                    <div class="col-md-12">
                      <label for="example-text-input" class="form-control-label"
                        >Nama Keluarga</label
                      >
                      <argon-input type="text" v-model:value="datas.NAMA_KELUARGA" disabled="true" />
                    </div>
                    <div class="col-md-12">
                      <label for="example-text-input" class="form-control-label"
                        >Status</label
                      >
                      <VueMultiselect
                        v-model="datas.STATUS"
                        :options="data_status"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="-"
                        label="nama"
                        track-by="nama"
                        :disabled="true"
                      />
                    </div>
                    <div class="col-md-12">
                      <label for="example-text-input" class="form-control-label"
                        >Status Aktif</label
                      >
                      <VueMultiselect
                        v-model="datas.STATUS_AKTIF"
                        :options="[{'id': '1', 'nama':'Aktif'},{'id': '0', 'nama':'Tidak Aktif'}]"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="-"
                        label="nama"
                        track-by="nama"
                        :disabled="true"
                      />
                    </div>
                    <div class="col-md-12">
                      <label for="example-text-input" class="form-control-label"
                        >Alamat</label
                      >
                      <argon-input type="text" v-model:value="datas.ALAMAT" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Kota</label
                      >
                      <argon-input type="text" v-model:value="datas.KOTA" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Provinsi</label
                      >
                      <argon-input type="text" v-model:value="datas.PROPINSI" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Negara</label
                      >
                      <argon-input type="text" v-model:value="datas.NEGARA" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Kodepos</label
                      >
                      <argon-input type="text" v-model:value="datas.KODEPOS" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Telp / HP</label
                      >
                      <argon-input type="text" v-model:value="datas.TELP" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tanggal Nikah</label
                      >
                      <argon-input type="date" v-model:value="datas.TGL_NIKAH" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tempat Nikah</label
                      >
                      <argon-input type="text" v-model:value="datas.TEMPAT_NIKAH" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tanggal Capil</label
                      >
                      <argon-input type="date" v-model:value="datas.TGL_CAPIL" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tempat Capil</label
                      >
                      <argon-input type="text" v-model:value="datas.TEMPAT_CAPIL" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Keterangan Khusus</label
                      >
                      <argon-input type="text" v-model:value="datas.KET_KHUSUS" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tanggal Masuk</label
                      >
                      <argon-input type="date" v-model:value="datas.TANGGAL_MASUK" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tanggal Keluar</label
                      >
                      <argon-input type="date" v-model:value="datas.TANGGAL_KELUAR" disabled="true" />
                    </div>
                  </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <auth-check></auth-check>
  </main>
</template>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<script>
/* eslint-disable */
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import VueMultiselect from 'vue-multiselect'
import AuthCheck from '@/components/authCheck.vue'

const body = document.getElementsByTagName("body")[0];

export default {
  name: "view-data-keluarga",
  data() {
    return {
      showMenu: false,
      datas: {
        ID: 0,
        ID_KELUARGA: 0,
        SEKTOR: '',
        WILAYAH: '',
        STATUS_KELUARGA: '',
        NAMA_KELUARGA: '',
        STATUS: '',
        ALAMAT: '',
        KOTA: '',
        PROPINSI: '',
        KODEPOS: '',
        NEGARA: '',
        TELP: '',
        KET_KHUSUS: '',
        TGL_NIKAH: '',
        TGL_CAPIL: '',
        TEMPAT_CAPIL: '',
        TEMPAT_NIKAH: '',
      },
      data_wilayah: [],
      data_sektor: [],
      data_status: [],
    };
  },
  components: {
    ArgonInput,
    VueMultiselect,
    ArgonButton,
    AuthCheck,
  },
  methods: {
    back(){
      this.$router.push("/data-keluarga");
    },
  },
  mounted() {
    this.$store.state.isAbsolute = true;
    this.axios.get(process.env.VUE_APP_API_URL + "data", {headers: {
      "Authorization": "Bearer " + localStorage.getItem("token")
    }}).then((resp) => {
      this.data_wilayah = JSON.parse(JSON.stringify(resp.data)).wilayah
      this.data_sektor = JSON.parse(JSON.stringify(resp.data)).sektor
      this.data_status = JSON.parse(JSON.stringify(resp.data)).status
    });
    this.axios.get(process.env.VUE_APP_API_URL + "keluarga/"+this.$route.params.id, {headers: {
        "Authorization": "Bearer " + localStorage.getItem("token")
      }}).then((resp) => {
        this.datas = JSON.parse(JSON.stringify(resp.data.data))
        if(this.datas.STATUS_AKTIF == "1"){
          this.datas.STATUS_AKTIF = {'id': '1', 'nama':'Aktif'}
        } else {
          this.datas.STATUS_AKTIF = {'id': '0', 'nama':'Tidak Aktif'}
        }
      })
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = false;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>
